import { ChatHistoryItem, ChatHistoryItemDetails, Domain, FeedbackReason } from "../../api";

export const enum HistoryProviderOptions {
    None = "none",
    CosmosDB = "cosmosDB"
}

export interface GiveFeedbackParams {
    conversationId: string;
    positive: boolean;
    turnIndex: number;
    comment?: string;
    idToken?: string;
    reason?: FeedbackReason;
}

export interface IHistoryProvider {
    getProviderName(): HistoryProviderOptions;
    resetContinuationToken(): void;
    getNextItems(count: number, idToken?: string, domain?: Domain): Promise<ChatHistoryItem[]>;
    getItem(id: string, idToken?: string): Promise<ChatHistoryItemDetails | null>;
    deleteItem(id: string, idToken?: string): Promise<void>;
    giveFeedback({ conversationId, positive, turnIndex, comment, idToken }: GiveFeedbackParams): Promise<void>;
}
